// extracted by mini-css-extract-plugin
module.exports = {"pagination":"JPm9C"};